<!-- MODAL HEADER -->
<div class="modal-header">
  <h3 class="modal-title"><strong>First Tier Investments Adjustments</strong></h3>
  <div class="header-actions">
    <i class="fa" [ngClass]="{'fa-plus-square-o': minimise, 'fa-minus-square-o': !minimise}"
       style="margin-right: 10px; cursor: pointer;" (click)="minimise=!minimise"></i>
    <i (click)="cancel()" class="fa fa-times" style="cursor: pointer;"></i>
  </div>
</div>

<!-- MODAL BODY -->
<form class="form-horizontal" [hidden]="minimise" novalidate>
<div class="modal-body no-body-scroll">

  @if (loadingData) {
<div class="modal-loading">
    <div class="loading-img">
      <i class="fa fa-spinner fa-pulse" style="font-size: 40px;"></i>
    </div>
  </div>
}

  @if (!loadingData) {
<div>

    <!-- Grid Row Info Table -->
    <div style="max-height: 100px; overflow-y: auto; overflow-x: auto; margin-bottom: 10px;">
      <table class="table table-hover table-bordered table-striped table-condensed" style="margin-bottom: 0;">
        <thead>
          <tr>
            <th>Home Office LEID</th>
            <th>Home Office Tax Code</th>
            <th>Home Office Reporting Period</th>
            <th>Maintenance Owner Name</th>
            <th>LE Name</th>
          </tr>
        </thead>
        <tbody>
          @for (t of selectedGridRow; track $index) {
<tr>
            <td>{{ t.HO_LEID }}</td>
            <td>{{ t.HO_CDR_NO }}</td>
            <td>{{ t.HO_REPORTING_PERIOD }}</td>
            <td>{{ t.MAINTENANCE_OWNER_DESC }}</td>
            <td>{{ t.LE_NAME }}</td>
          </tr>
}
        </tbody>
      </table>
    </div>

    <!-- Edit Form -->
    <input [(ngModel)]="adjObj.adj_key" type="hidden" name="adj_key">
    <div class="row">
      <div class="col-sm-4">
        <label for="adjType">Adjustment Type*:</label>
        <select id="adjType" class="form-control input-sm"
                [(ngModel)]="selectedAdjType" name="adjType" required>
          <option value="">--Select Adj Type--</option>
          @for (x of adjustmentTypeDropdown; track $index) {
<option [value]="x.CODE_KEY">
            {{ x.CODE_DESC }}
          </option>
}
        </select>
      </div>
      <div class="col-sm-4">
        <label for="adj_date">Date*:</label>
        <input [(ngModel)]="adjObj.adj_date" type="date" id="adj_date" name="adj_date"
               class="form-control input-sm">
      </div>
      <div class="col-sm-4">
        <label for="amt">Adjustment Amount*:</label>
        <input [(ngModel)]="adjObj.amount" type="number" id="amt" name="amt"
               class="form-control input-sm" step="0.01" (blur)="roundAmountToTwoDecimals()">
      </div>
    </div>
    <div class="row" style="margin-top: 10px;">
      <div class="col-sm-8">
        <label for="adjDesc">Adjustment Description:</label>
        <input type="text" [(ngModel)]="adjObj.adj_desc" id="adjDesc" name="adjDesc"
               class="form-control input-sm">
      </div>
    </div>

    <!-- Adjustment Details Table -->
    <div style="margin-top: 15px;">
      <table class="table table-striped table-bordered table-condensed" style="text-align: left; width: 100%;">
        <thead>
          <tr>
            <th>Edit</th>
            <th>Adjustment Type</th>
            <th>Date</th>
            <th>Adjustment Amount</th>
            <th>Adjustment Desc</th>
          </tr>
        </thead>
        <tbody>
          @for (t of getSortedAdjustmentDtls(); track trackByAdjKey($index, t)) {
<tr>
            <td style="width: 1%;">
              <i style="font-size: 18px; cursor: pointer;"
                 class="fa fa-pencil-square-o"
                 aria-hidden="true"
                 title="Edit Adjustments"
                 (click)="editRow(t)"></i>
            </td>
            <td>{{ t.ADJ_TYPE }}</td>
            <td>{{ t.ADJ_DATE }}</td>
            <td style="text-align: right;" [ngClass]="{'color-red': t.AMOUNT < 0}">
              {{ t.AMOUNT | numberWithCommas }}
            </td>
            <td>{{ t.ADJ_DESC }}</td>
          </tr>
}
          <tr>
            <td colspan="3" style="text-align: right; font-weight: bold;">Total Adj Amount</td>
            <td style="text-align: right;" [ngClass]="{'color-red': totalAdjAmt < 0}">
              {{ totalAdjAmt | numberWithCommas }}
            </td>
            <td></td>
          </tr>
        </tbody>
      </table>
    </div>

  </div>
}
</div>
</form>

<!-- MODAL FOOTER -->
<div class="modal-footer" [hidden]="minimise">
  <button class="btn btn-info btn-sm" type="button" [disabled]="isSaveClicked" (click)="save()" style="margin-right: 5px;">
    @if (crudLoading) {
<span><i class="fa fa-spinner fa-pulse"></i></span>
} Save
  </button>
  <button class="btn btn-info btn-sm" type="button" [disabled]="isSaveClicked" (click)="saveAndClose()" style="margin-right: 5px;">
    @if (crudLoading) {
<span><i class="fa fa-spinner fa-pulse"></i></span>
} Save &amp; Close
  </button>
  <button class="btn btn-warning btn-sm" type="button" (click)="cancel()">Cancel</button>
</div>
